import React, { useEffect } from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSplitClient } from '@splitsoftware/splitio-react';

// CONSTANTS
import {
  ROUTE_PARTNER_FORM,
  ROUTE_PARTNER_START,
  ROUTE_PARTNER_VIDEO_MIGRATION,
  ROUTE_START_NOW,
} from '@/constants/routes';
import TreatmentNames from '@/constants/split';

// UTILITY
import { FMBOnePageView, FMBChangeFlowVariant } from '@/utility/split';

// HOOKS
import useRouterMatch from '@/hooks/useRouterMatch';

// HOC
import withSplit from '@/hoc/withSplit';

// COMPONENTS
import Loader from '@/components/Loader';

// HELP
import StartOnePageContent from './StartOnePageContent';
import StartContent from './StartContent';

const Start = () => {
  const [t] = useTranslation();
  const { isPartnerDomain, partnerData, partnerLoading } = useSelector(({ partner }) => ({
    isPartnerDomain: partner.isPartnerDomain,
    partnerData: partner.data,
    partnerLoading: partner.loadings.partner,
  }));
  const { client: splitClient, isReady } = useSplitClient();

  useEffect(() => {
    window.prerendercloudReady = false;
  }, []);

  function getVariantFlow() {
    const treatmentsData = splitClient?.getTreatmentsWithConfig([TreatmentNames.FMB_CHANGE_FLOW]);

    return FMBChangeFlowVariant.getVariant(treatmentsData);
  }

  const isPartner = !!partnerData?.slug;
  const partnerSettings = partnerData.settings || {};
  let useOnePageView = !!partnerSettings?.use_fmb_one_page_view;
  let variant;

  const isPartnerLink =
    useRouterMatch({ path: ROUTE_START_NOW }) ||
    useRouterMatch({ path: ROUTE_PARTNER_VIDEO_MIGRATION }) ||
    useRouterMatch({ path: ROUTE_PARTNER_FORM }) ||
    useRouterMatch({ path: ROUTE_PARTNER_START }) ||
    isPartnerDomain;

  if (!isReady || partnerLoading) return <Loader active text={t('channels.loaders.questions')} />;

  if (!isPartner) {
    const treatmentsData = splitClient?.getTreatmentsWithConfig([TreatmentNames.FMB_ONE_PAGE_VIEW]);
    const variantPageView = FMBOnePageView.getVariant(treatmentsData);

    if (variantPageView === FMBOnePageView.Variant.on) {
      useOnePageView = true;
    }
  }

  if (useOnePageView) {
    variant = !isPartner ? getVariantFlow() : undefined;

    return <StartOnePageContent isPartnerLink={isPartnerLink} flowVariant={variant} />;
  }

  variant = !isPartnerLink ? getVariantFlow() : undefined;

  return <StartContent isPartnerLink={isPartnerLink} flowVariant={variant} />;
};

export default compose(
  withSplit(), // should always be the first!
)(Start);
